
import React, { useState, useEffect, useRef } from "react";


const FULL_TEXT = "Need a lawyer?";
const SEQUENCE = [
  "Need a lawyer?",
  "Need alawyer?",
  "Needalawyer?",
  "Needalawyer",
  "Needalawye",
  "Needalawy",
  "Needalaw",
  "Needala",
  "Needal",
];
const DELAY = 2000; // ms before starting collapse
const INTERVAL = 80; // ms per step

const LogoAnimated = () => {
  const [displayText, setDisplayText] = useState(FULL_TEXT);
  const intervalRef = useRef();
  const timeoutRef = useRef();
  const isCollapsed = useRef(false);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      let step = 0;
      intervalRef.current = setInterval(() => {
        if (step < SEQUENCE.length) {
          setDisplayText(SEQUENCE[step]);
          step++;
        } else {
          clearInterval(intervalRef.current);
          isCollapsed.current = true;
        }
      }, INTERVAL);
    }, DELAY);
    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, []);

  const handleMouseEnter = () => {
    // Instantly restore full text on hover
    clearTimeout(timeoutRef.current);
    clearInterval(intervalRef.current);
    setDisplayText(FULL_TEXT);
    isCollapsed.current = false;
  };

  const handleMouseLeave = () => {
    // Start collapsing again after mouse leaves
    if (!isCollapsed.current) {
      timeoutRef.current = setTimeout(() => {
        let step = 0;
        intervalRef.current = setInterval(() => {
          if (step < SEQUENCE.length) {
            setDisplayText(SEQUENCE[step]);
            step++;
          } else {
            clearInterval(intervalRef.current);
            isCollapsed.current = true;
          }
        }, INTERVAL);
      }, 300);
    }
  };

  return (
    <span
      className="logo-animated cursor-pointer font-bold text-2xl"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ display: "inline-block", whiteSpace: "nowrap", overflow: "hidden", verticalAlign: "middle", transition: "none" }}
    >
      <span style={{ display: "inline-block" }}>{displayText}</span>
    </span>
  );
};

export default LogoAnimated;
